import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Home, Users, Briefcase, FileText, Receipt } from "lucide-react";
import { Link, matchPath, useLocation } from "react-router";

export const MobileNavigation = () => {
  const location = useLocation();

  const getCurrentPath = () => {
    if (matchPath("/", location.pathname)) return "/";
    if (matchPath("/contacts/*", location.pathname)) return "/contacts";
    if (matchPath("/jobs/*", location.pathname)) return "/jobs";
    if (matchPath("/proposals/*", location.pathname)) return "/proposals";
    if (matchPath("/invoices/*", location.pathname)) return "/invoices";
    return false;
  };

  const currentPath = getCurrentPath();

  // Check if the app is running as a PWA (standalone mode)
  const isPwa = window.matchMedia("(display-mode: standalone)").matches;
  // Check if it's iOS on the web
  const isWebiOS = /iPad|iPod|iPhone/.test(window.navigator.userAgent);

  return (
    <nav
      aria-label="Main navigation"
      className="fixed bottom-0 left-0 right-0 z-50 bg-secondary h-14"
      style={{
        paddingBottom: isPwa && isWebiOS ? 15 : undefined,
        height:
          "calc(var(--spacing)) * 6" + (isPwa && isWebiOS ? " + 15px" : ""),
      }}
    >
      <div className="flex justify-center">
        <NavigationButton
          href="/"
          Icon={Home}
          label="Home"
          isActive={currentPath === "/"}
        />
        <NavigationButton
          href="/contacts"
          Icon={Users}
          label="Contacts"
          isActive={currentPath === "/contacts"}
        />
        <NavigationButton
          href="/jobs"
          Icon={Briefcase}
          label="Jobs"
          isActive={currentPath === "/jobs"}
        />
        <NavigationButton
          href="/proposals"
          Icon={FileText}
          label="Proposals"
          isActive={currentPath === "/proposals"}
        />
        <NavigationButton
          href="/invoices"
          Icon={Receipt}
          label="Invoices"
          isActive={currentPath === "/invoices"}
        />
      </div>
    </nav>
  );
};

const NavigationButton = ({
  href,
  Icon,
  label,
  isActive,
}: {
  href: string;
  Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  label: string;
  isActive: boolean;
}) => (
  <Button
    asChild
    variant="ghost"
    className={cn(
      "flex-col gap-1 h-auto py-2 px-1 rounded-md w-16",
      isActive ? null : "text-muted-foreground",
    )}
  >
    <Link to={href}>
      <Icon className="size-6" />
      <span className="text-[0.6rem] font-medium">{label}</span>
    </Link>
  </Button>
);
